// extracted by mini-css-extract-plugin
export var articleDate = "index-module--articleDate--N59nT";
export var authorAndSocialContainer = "index-module--authorAndSocialContainer--kntjo";
export var authorName = "index-module--authorName--o2nhU";
export var blogContent = "index-module--blogContent--Hckc6";
export var container = "index-module--container--M2vkL";
export var thumbnailImage = "index-module--thumbnailImage--dNaG9";
export var title = "index-module--title--xf5bh";